module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-448.0291939.woff2";